webpackJsonp([14],{

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_ru__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment_locale_ru___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment_locale_ru__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_eonasdan_bootstrap_datetimepicker__);




var date = document.dateString === '' ? Date.now() : __WEBPACK_IMPORTED_MODULE_0_moment___default()(document.dateString, 'YYYY-MM-DD');

var datePicker = $("#archive-datepicker").find("div").datetimepicker({
    inline: true,
    viewMode: 'days',
    format: 'yyyy-MM-dd',
    enabledDates: document.availableDates,
    defaultDate: date,
    locale: 'ru'
});

datePicker.on("dp.change", function (event) {
    location.href = "/news/" + __WEBPACK_IMPORTED_MODULE_0_moment___default()(event.date).format('YYYY/MM/DD');
});
;

var _temp = function () {
    if (typeof __REACT_HOT_LOADER__ === 'undefined') {
        return;
    }

    __REACT_HOT_LOADER__.register(date, 'date', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/newsList.js');

    __REACT_HOT_LOADER__.register(datePicker, 'datePicker', '/builds/site/tgt72ru/deployment/build-pkg/debian/tgt72ru/opt/tgt72ru/src/js/newsList.js');
}();

;
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ })

},[549]);


// WEBPACK FOOTER //
// newsList.js